const SubformTemplate ={
        "children":[
           {
              "style":{
                 
              },
              "id":"GroupInfo"
           },
           {
              "children":[
                 {
                    "style":{
                       
                    },
                    "id":"Event"
                 }
              ],
              "style":{
                 
              },
              "id":"RootControl",
              "event":{
                 "name":"Event",
                 "Event":[
                    {
                       "Events":[
                          
                       ],
                       "name":"Events"
                    }
                 ]
              },
              "elem_type":"form"
           }
        ],
        "customControl":[
           {
              "iconName":"1.jpg",
              "iconFile":"1.jpg",
              "label":"Custom1",
              "properties":[
                 {
                    "color":"red"
                 }
              ],
              "elem_type":"CustomControl"
           },
           {
              "iconName":"select",
              "iconFile":"select",
              "label":"custom2",
              "properties":[
                 {
                    "color":"blue"
                 }
              ],
              "elem_type":"CustomControl"
           }
        ],
        "formName":"testForm",
        "ElementCount":{
           "paragraph":1,
           "textbox":1,
           "textarea":1,
           "video":1,
           "Step":1,
           "radio":1,
           "button":1,
           "tab":1,
           "SubStep":1,
           "checkbox":1,
           "sheet":1,
           "iframe":1,
           "map":1,
           "table":1,
           "EmptyRow":1,
           "image":1,
           "datepick":1,
           "EmptyCell":1,
           "combo":1,
           "toggle":1,
           "label":1,
           "listbox":1,
           "headerframe":1,
           "CustomControl":1,
           "imagecarousel":1,
           "MainMenu": 1,
           "frame":1
        },
        "theme":{
           "themeName":"Default Theme",
           "ActiveStateStyle":{
              "ActiveStates":"#0072c6"
           },
           "SectionStyle":{
              "ControlStyle":"Style3",
              "HeaderBackColor":"#FFFFFF",
              "BorderColor":"#E4E4E4",
              "FontWeight":"Bold"
           },
           "InputStyle":{
              "ValueFontWeight":"Normal",
              "BorderRadius":"2px",
              "BorderColor":"#DFE3E9",
              "LabelFontWeight":"Semibold",
              "BorderWidth":"1px",
              "LabelValueAlignment":"Top Bottom",
              "ControlStyleTextbox":"Style1",
              "ControlStyleRadio":"Style2",
              "ControlStyleCheckbox":"Style1",
              "ControlStyleToggle":"Style1"
           },
           "BasicTheme":{
              "TabSelectionsHeaderColor":"#168edd",
              "ActiveStates":"#0072c6",
              "FontColor":"#0072C6",
              "FontFamily":"Open Sans",
              "FontSize":"12px"
           },
           "TabSheetStyle":{
              "TabSelectionsHeaderColor":"#168edd"
           },
           "ButtonStyle":{
              "CornerRadius":"2px",
              "FontWeight":"Bold",
              "BackgroundColor":"#FFFFFF"
           },
           "HorizontalTabStyle":{
              "ControlStyle":"Style3",
              "ActiveTabBackColor":"#FFFFFF",
              "InActiveTabBackColor":"#168EDD",
              "BorderRadius":"2px"
           },
           "TableStyle":{
              "TableColumnBackgroundColor":"#168EDD14",
              "TableColumnFontWeight":"600",
              "TableRowFontWeight":"Bold",
              "TableRowBackgroundColor":"#FFFFFF",
              "ControlStyle":"Box",
              "TableTitleFontWeight":"Bold"
           }
        },
        "style":{
           "FontStyle":"1",
           "ImageFormUrl":"",
           "GradientColor1":"#transparent",
           "EnableSliderArrows":"false",
           "ImageAllignment":"Center",
           "CombinedFontWeight":"Bold",
           "GradientColor2":"#transparent",
           "SelectedCarouselImages":"",
           "HeaderAllignment":"center",
           "ScreenBackgroundImage":"",
           "FormMaxWidth":"",
           "FormWidthType":"1",
           "FontWeight":"2",
           "FormBorderWidth":"0px",
           "FormHorizontal":"false",
           "FormVertical":"center",
           "FormAllignments":"",
           "AllowAutoScroll":"false",
           "ShowHeader":"true",
           "GradientPercent1":"0",
           "GradientPercent2":"100",
           "BoderSize":"0",
           "FormWidth":"100",
           "TopPercent":"0",
           "height":"100%",
           "FontFamily":"2",
           "Breakpoint":{
              "Desktop":{
                 "StartValue":"1000",
                 "EndValue":"1250"
              },
              "Tab":{
                 "StartValue":"750",
                 "EndValue":"1000"
              },
              "Mobile":{
                 "StartValue":"320",
                 "EndValue":"750"
              }
           },
           "Breakpoints":[
               {
                  "StartValue":"1000",
                  "EndValue":"1250",
                  "device":"Desktop"
               },
               {
                  "StartValue":"750",
                  "EndValue":"1000",
                  "device":"Tab"
               },
               {
                  "StartValue":"320",
                  "EndValue":"750",
                  "device":"Mobile"
               }
           ],
           "CurrentDevice":{
              
           },
           "ScreenBackgroundRadio":"bgcolor",
           "BackColor":"#ffffff",
           "BackColorBoundary":"#ffffff",
           "FontColor":"#000000",
           "GradientAngles":"",
           "LeftPercent":"0",
           "FormBackgroundColor":"#ffffff",
           "FitToContentHeight":"false",
           "FontSize":"18px",
           "FixHeader":"1",
           "FormMinWidth":"",
           "InputStyle":"",
           "FormBorderColor":"#d7d7d7",
           "CanvasWidth":1230,
           "width":"100%",
           "ScreenBgImgWidth":"",
           "AddGradient":"false",
           "RightPercent":"0",
           "ScreenBackgroundColor":"#ffffff"
        },
        "ControlType":"form",
        "id":"FormDef",
        "controlSet":[
           
        ],
        "ZoneList":[
           
        ],
        "elem_type":"form",
        "pageStyle": { BackgroundColor: "#FFFFFF", SubformTitle: "Subform" },
     };

export default SubformTemplate